import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import { colors } from 'theme/theme';

export const Link = styled(StyledVersionedRouterLink)`
  letter-spacing: 0.44px;

  &:hover {
    text-decoration: none;
  }
`;

export const ResultsCount = styled.div`
  padding: 0 10px;
  margin: 0 10px;
  border: 1px solid ${colors.elementGrey};
  border-width: 0 1px;
  color: ${colors.lightContentGrey};
`;
